// Constants for cluster marker
export const CLUSTER_SIZE = 50;

// Helper function to generate SVG for cluster marker
export const generateClusterMarkerSvg = (size: number, color: string) => `
  <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="1" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.3)" />
      </filter>
    </defs>
    <circle cx="${size / 2}" cy="${size / 2}" r="${
  size / 2 - 3
}" fill="${color}" filter="url(#shadow)" />
  </svg>
`;

export const generateClusterMarkerIcon = (color: string) => {
  const svg = generateClusterMarkerSvg(CLUSTER_SIZE, color);

  return {
    url: `data:image/svg+xml;base64,${btoa(svg)}`,
    height: CLUSTER_SIZE,
    width: CLUSTER_SIZE,
    textColor: "black",
    textSize: 14,
    backgroundPosition: "center",
  };
};
